import { combineReducers } from "redux";
import forgotPassword from "./actions/forgotPassword";
import getRoles from "./actions/getRoles";
import getUsersPaginated from "./actions/getUsersPaginated";
import linkerRole from "./actions/linkerRole";
import registerUser from "./actions/registerUser";
import resetPassword from "./actions/resetPassword";

export const users = combineReducers({
  getUsersPaginated,
  getRoles,
  linkerRole,
  registerUser,
  forgotPassword,
  resetPassword
});
